import { enumParser } from '#validation/common/parsers';
import { AllowedPermissions } from '../constants';
export const allowedPermissionsParser = enumParser(AllowedPermissions);
